import Plan from '../../Constants/Plan';

export default function isLegacyPlan(plan) {
  if (plan?.id === Plan.NON_MEMBER.id) return false;
  return plan?.active === false;
}
